<template>
  <div role="radiogroup" :aria-label="label" class="inline-flex w-full p-0.5 rounded-lg bg-gray-100 dark:bg-gray-800">
    <button v-for="option in options" :key="option.value" type="button" role="radio" :aria-checked="modelValue === option.value"
      @click="$emit('update:modelValue', option.value)"
      class="flex-1 h-7 px-2 rounded-md text-xs font-semibold transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500/50"
      :class="modelValue === option.value
        ? 'bg-white dark:bg-[#0d1117] text-gray-900 dark:text-white shadow-sm'
        : 'text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200'">{{ option.label }}</button>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, default: '' },
  options: { type: Array, required: true }, // [{ value, label }]
  label: { type: String, required: true },
})
defineEmits(['update:modelValue'])
</script>
